module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-wrapper"
  }, [_c('component-header'), _vm._v(" "), _c('div', {
    staticClass: "main"
  }, [_c('div', {
    staticClass: "outer-admin"
  }, [_c('div', {
    staticClass: "wrapper-admin"
  }, [_c('component-sidebar'), _vm._v(" "), _c('div', {
    staticClass: "content-admin"
  }, [_c('div', {
    staticClass: "content-admin-wrapper"
  }, [_c('div', {
    staticClass: "content-admin-main"
  }, [_c('div', {
    staticClass: "content-admin-main-inner"
  }, [_c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 col-lg-12",
    staticStyle: {
      "margin-right": "5em"
    }
  }, [_c('div', {
    staticClass: "content fld-left"
  }, [_c('div', {}, [_c('div', {
    attrs: {
      "role": "",
      "id": "one"
    }
  }, [_c('div', {
    staticClass: "fld-lft-adjust"
  }, [_vm._m(0), _vm._v(" "), (_vm.loading) ? _c('div', {
    staticClass: "row"
  }, [_vm._m(1)]) : _c('div', [_c('div', {
    staticClass: "pull-right col-md-3 col-xs-12 wallet-background p20 mb30"
  }, [_c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('div', {
    staticClass: "pull-left"
  }, [_c('p', [_vm._v("Your Referral Code")]), _vm._v(" "), _c('h2', {
    staticStyle: {
      "color": "#f2f2f2"
    }
  }, [_vm._v(_vm._s(_vm.referral_code))]), _vm._v(" "), _c('div', {
    staticClass: "ref-links"
  }, [_c('p', [_vm._v("Share Your Referral Code")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "22px",
      "margin-left": "-1em"
    }
  }, [_c('a', {
    staticStyle: {
      "color": "#ffffff"
    },
    attrs: {
      "href": 'http://www.facebook.com/sharer.php?u=' + _vm.site_url,
      "target": "_blank",
      "title": "Share on Facebook"
    }
  }, [_c('i', {
    staticClass: "fa fa-facebook"
  })]), _vm._v(" "), _c('a', {
    staticStyle: {
      "color": "#ffffff"
    },
    attrs: {
      "href": 'https://twitter.com/share?url=' + _vm.site_url + '&hashtags=cityneeds,paybills,buyairtime,surveys,discussions,findworkers,',
      "target": "_blank",
      "title": "Share on Twitter"
    }
  }, [_c('i', {
    staticClass: "fa fa-twitter"
  })]), _vm._v(" "), _c('a', {
    staticStyle: {
      "color": "#ffffff"
    },
    attrs: {
      "href": 'whatsapp://send?text=' + _vm.site_url,
      "data-action": _vm.site_url,
      "target": "_blank",
      "title": "Share on Whatsapp"
    }
  }, [_c('i', {
    staticClass: "fa fa-whatsapp"
  })]), _vm._v(" "), _c('a', {
    staticClass: "linky",
    staticStyle: {
      "cursor": "pointer",
      "color": "#ffffff"
    },
    attrs: {
      "title": "Copy Link and Share"
    },
    on: {
      "click": function($event) {
        _vm.copyLink()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-link",
    attrs: {
      "id": "copiied"
    }
  })])]), _vm._v(" "), _c('p', {
    attrs: {
      "align": "center"
    }
  }, [(_vm.copy_succ) ? _c('span', {
    staticStyle: {
      "color": "#000000",
      "background": "#ffff00",
      "font-size": "12px",
      "padding": "3px"
    }
  }, [_vm._v("Copied")]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })]), _vm._v(" "), (_vm.referrals.length != 0) ? _c('div', {
    attrs: {
      "id": "refferals"
    }
  }, [_c('div', {
    staticClass: " col-md-8 p20 mb30 hidden-sm hidden-xs"
  }, [_c('div', {
    staticClass: "p20",
    staticStyle: {
      "overflow-x": "auto",
      "background": "#ffffff"
    }
  }, [_vm._m(2), _vm._v(" "), _c('table', {
    staticClass: "table"
  }, [_vm._m(3), _vm._v(" "), _vm._l((_vm.referrals), function(ref) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(ref.referral_reg_date))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(ref.referral_referred))]), _vm._v(" "), _c('td', [_c('progress', {
      attrs: {
        "value": ref.referral_reward_obtained,
        "max": ref.referral_reward_to_obtain
      }
    }), _vm._v(" "), _c('i', {
      staticClass: "fa fa-info-circle",
      attrs: {
        "title": 'Your Referral has completed ' + ref.referral_reward_obtained + '/' + ref.referral_reward_to_obtain + ' transactions needed for you to earn reward'
      }
    })]), _vm._v(" "), _c('td', [_vm._v(_vm._s(ref.referral_status))])])
  })], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 background-white p20 mb30 hidden-md hidden-lg"
  }, [_vm._m(4), _vm._v(" "), _c('table', {
    staticClass: "table"
  }, _vm._l((_vm.referrals), function(ref) {
    return _c('tr', [_c('td', {
      staticStyle: {
        "padding": "1em"
      }
    }, [_c('p', [_c('b', [_vm._v("Date: ")]), _vm._v(_vm._s(ref.referral_reg_date))]), _vm._v(" "), _c('p', [_c('b', [_vm._v("Referred: ")]), _vm._v(_vm._s(ref.referral_referred))]), _vm._v(" "), _c('p', [_c('b', [_vm._v("Reward Progress: ")]), _c('progress', {
      attrs: {
        "value": ref.referral_reward_obtained,
        "max": ref.referral_reward_to_obtain
      }
    }), _vm._v(" "), _c('i', {
      staticClass: "fa fa-info-circle",
      attrs: {
        "title": 'Your Referral has completed ' + ref.referral_reward_obtained + '/' + ref.referral_reward_to_obtain + ' transactions needed for you to earn reward'
      }
    })]), _vm._v(" "), _c('p', [_c('b', [_vm._v("Status: ")]), _vm._v(_vm._s(ref.referral_status))])])])
  }))])]) : _c('div', [_c('p', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v("You have not made any Referrals yet")])])])])])])])])])])])]), _vm._v(" "), _c('component-footer')], 1)])], 1)])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-title"
  }, [_c('h1', [_vm._v("My Referrals")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-6 col-md-offset-5 col-sm-12",
    staticStyle: {
      "padding": "5em"
    }
  }, [_c('img', {
    attrs: {
      "src": "static/assets/img/loader.gif"
    }
  }), _vm._v(" "), _c('p', [_vm._v("loading...")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h5', [_c('u', [_vm._v("Your Referrals")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('th', [_vm._v("~"), _c('span', {
    staticStyle: {
      "font-size": "11px"
    }
  }, [_vm._v("Date")])]), _vm._v(" "), _c('th', [_vm._v("Referred")]), _vm._v(" "), _c('th', [_vm._v("Reward Progress")]), _vm._v(" "), _c('th', [_vm._v("Status")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h5', [_c('u', [_vm._v("Your Referrals")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-bd0b52d4"}!./src/components/MyReferrals/template.html
// module id = 315
// module chunks = 0